import { FC } from 'react';

interface PlaylistItemDropIndicatorV2Props {
  position: 'top' | 'bottom';
}

const PlaylistItemDropIndicatorV2: FC<PlaylistItemDropIndicatorV2Props> = ({
  position,
}) => {
  return (
    <div
      className="absolute left-0 right-0 h-0.5 bg-black pointer-events-none z-[1]"
      style={{
        top: position === 'top' ? -2 : undefined,
        bottom: position === 'bottom' ? 0 : undefined,
      }}
    />
  );
};

export default PlaylistItemDropIndicatorV2;
